import { RoomType } from 'src/models/Room'
import useSWR from 'swr'
import { IterableElement } from 'type-fest'
import { ApiClient } from './client'
import {
  deleteCompanyMessageRoomTag,
  GET_COMPANY_MESSAGE_ROOM_TAGS,
  POST_COMPANY_MESSAGE_ROOM_TAGS,
  putCompanyMessageRoomTag,
} from './endpoints'
import { ApiResponse } from './types'
import {
  CompanyMessageRoomTag,
  CompanyMessageRoomTagsResponse,
} from './types/companyMessageRoomTag'

export const useRoomTags = () =>
  useSWR<CompanyMessageRoomTag[]>(
    GET_COMPANY_MESSAGE_ROOM_TAGS,
    companyMessageRoomTagFetcher,
  )

const companyMessageRoomTagFetcher = async (url: string) => {
  const res = await ApiClient.get<CompanyMessageRoomTagsResponse>(url)
  if (res.error) return []
  return res.data?.companyMessageRoomTags.map(toCompanyMessageRoomTag) || []
}

const toCompanyMessageRoomTag = (
  data: IterableElement<
    CompanyMessageRoomTagsResponse['companyMessageRoomTags']
  >,
): CompanyMessageRoomTag => ({
  id: data.id,
  name: data.name,
  companyId: data.companyId,
})

type CreateTagRequest = {
  company_message_room_tag: {
    name: string
  }
}
type CreateTagResponse = {
  id: number
}
export const createTag = async (
  name: string,
): Promise<ApiResponse<CreateTagResponse>> => {
  const body: CreateTagRequest = {
    company_message_room_tag: {
      name,
    },
  }
  const res = await ApiClient.post<CreateTagResponse>(
    POST_COMPANY_MESSAGE_ROOM_TAGS,
    body,
  )
  if (res.error) return res
  return res
}

type CreateTagAndTagMappingRequest = CreateTagRequest & {
  room_id: number
  room_type: RoomType
}
type CreateTagAndTagMappingResponse = {
  id: number
  companyMessageRoomTagMappingId: number
}
export const createTagAndTagMapping = async (
  name: string,
  roomId: number,
  roomType: RoomType,
): Promise<ApiResponse<CreateTagAndTagMappingResponse>> => {
  const body: CreateTagAndTagMappingRequest = {
    company_message_room_tag: {
      name,
    },
    room_id: roomId,
    room_type: roomType,
  }
  const res = await ApiClient.post<CreateTagAndTagMappingResponse>(
    POST_COMPANY_MESSAGE_ROOM_TAGS,
    body,
  )
  if (res.error) return res
  return res
}

type RenameTagRequest = {
  company_message_room_tag: {
    name: string
  }
}
export const renameTag = async (id: number, name: string) => {
  const body: RenameTagRequest = {
    company_message_room_tag: {
      name,
    },
  }
  const res = await ApiClient.patch(putCompanyMessageRoomTag(id), body)
  if (res.error) return res
  return res.data
}

export const deleteTag = async (id: number) => {
  const res = await ApiClient.delete(deleteCompanyMessageRoomTag(id))
  if (res.error) return res
  return res.data
}
